import { BehaviorSubject } from 'rxjs';

import BaseService from './base.service';

export default class MaterialService extends BaseService {
  getMaterials(criteria) {
    const query = this.getQueryString(criteria);
    return this.get(`/materials${query}`);
  }

  createMaterial(payload, progress$ = new BehaviorSubject(0)) {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (['files', 'tags', 'thumbnail'].includes(key)) return;

      if (payload[key] !== null && payload[key] !== undefined) {
        if (key === 'category') formData.append('categories[0]', payload[key]);
        else formData.append(key, payload[key]);
      }
    });

    payload.files.forEach((file) => {
      formData.append(`files`, file);
    });

    if (payload.thumbnail) {
      formData.append('thumbnails', payload.thumbnail);
    }

    if (payload.tags && payload.tags.length) {
      payload.tags.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag);
      });
    }

    formData.append('isWeb', true);

    return this.sendFormData('POST', '/materials', formData, progress$);
  }

  updateMaterial(payload, id, $progress) {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (['tags', 'thumbnail'].includes(key)) return;
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    });

    if (payload.thumbnail) {
      formData.append('thumbnails', payload.thumbnail);
    }

    if (payload.tags && payload.tags.length) {
      payload.tags.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag);
      });
    }

    return this.sendFormData('PUT', `/materials/${id}`, formData, $progress);
  }

  deleteMaterial(id) {
    return this.delete(`/materials/${id}`);
  }

  getAnatomies() {
    return this.get('/materials/anatomies');
  }

  getModalities() {
    return this.get('/materials/modalities');
  }

  getTags() {
    return this.get('/materials/tags?limit=500');
  }

  getMaterialDetails(id) {
    return this.get(`/materials/${id}`);
  }
}
